export const LOGIN_URL = `/api/v1/admin/login`;
export const LOGOUT_URL = `/api/v1/account/logout`;
export const SEND_REPORT = `/api/v1/report/`;

export const USER_URL = `/api/v1/userServlet`;
export const CONTACT_URL = `/api/v1/admin/searchContact`;
export const CONTACT_URL_V2 = `/api/v1/admin/contact`;
export const CONTACT_FIELDS_URL = `/api/v1/admin/getContactFields`;

export const LOAD_CONFIG_URL = `/api/v1/admin/loadDialogConfig`;
export const GET_ROUTE_LIST_URL = `/api/v1/admin/loadRouteList`;
export const GET_ROUTE_BY_IDS = '/api/v1/admin/route/get-by-ids';
export const CARRIER_URL = `/api/v1/admin/contact/loadCarrierList`;
export const AVAILABLE_COUNTRIES_URL = `/api/v1/admin/availableCountries`;

export const FIND_PHONE_URL = `/api/v1/admin/findPhone`;

export const SEARCH_CAMPAIGN_URL = `/api/v1/admin/searchCampaigns`;
export const SEARCH_BLACKLIST_URL = `/api/v1/admin/searchBlacklist`;
export const COUNT_BLACKLIST_URL = `/api/v1/admin/countBlacklist`;
export const SEARCH_BLACKLIST_MD5_URL = `/api/v1/admin/searchBlacklistMd5`;
export const COUNT_BLACKLIST_MD5_URL = `/api/v1/admin/countBlacklistMd5`;
export const DELETE_BLACKLIST_URL = `/api/v1/admin/deletePhoneInBlacklist`;
export const DELETE_BLACKLIST_MD5_URL = `/api/v1/admin/deletePhoneInBlacklistMd5`;
export const ADD_SINGLE_BLACKLIST_URL = `/api/v1/admin/addSingleBlacklist`;
export const UPLOAD_BLACKLIST_URL = `/api/v1/file/uploadBlacklistFile`;
export const IMPORT_FROM_OPTIZMO_MAILER_URL = `/api/v1/admin/importFromOptizmoMailer`;

export const LOAD_PRICE_URL = `/api/v1/admin/loadPriceTable`;
export const SAVE_PRICE_URL = `/api/v1/admin/savePriceTable`;

export const SEARCH_DID_URL = `/api/v1/admin/searchDids`;
export const COUNT_DID_URL = `/api/v1/admin/countDids`;
export const DELETE_DIDS_URL = `/api/v1/admin/deleteDids`;
export const LOAD_DID_GROUPS = `/api/v1/admin/did/loadDidGroups`;
export const LINK_10DLC_STATUS_URL = `/api/v1/admin/did/link10dlcStatus`;
export const EXPORT_DID_URL = `/api/v1/admin/exportDids`;
export const DELETE_DIDS_BY_LIST = `/api/v1/admin/deleteDidsByList`;

export const SEARCH_DID_HISTORY_URL = `/api/v1/admin/searchDidHistory`;
export const COUNT_DID_HISTORY_URL = `/api/v1/admin/countDidHistory`;
export const GENERATE_VIRTUAL_DID_URL = `/api/v1/admin/generateVirtualDid`;

export const LIST_DEVICE_URL = `/api/v1/admin/device/list`;
export const LIST_DEVICE_BY_RANGES_URL = `/api/v1/admin/device/search-by-range`;
export const COUNT_DEVICE_URL = `/api/v1/admin/device/count`;
export const FARM_LIST_DEVICE_URL = `/api/v1/admin/device/farm/list`;
export const ALL_SENT_HISTORY_URL = `/api/v1/admin/device/all-sent-history`;
export const ALL_CLICK_HISTORY_URL = `/api/v1/admin/device/all-click-history`;
export const SEND_MESSAGE_DEVICE_URL = `/api/v1/admin/device/sendMessage`;
export const ALL_STATUS_HISTORY_URL = `/api/v1/admin/device/all-status-history`;
export const NUMBER_POOL_VENDORS = '/api/v1/admin/device/number-pool-vendors';
export const IMPORT_NUMBER_POOL_URL = '/api/v1/admin/number-pool-import';
export const NUMBER_POOL_SEARCH = '/api/v1/admin/number-pool-search';

export const NUMBER_POOL_URL = '/api/v1/admin/general/number-pool';

export const CREATE_WORKER_URL = `/api/v1/admin/device/farm/create-login`;
export const CREATE_FARM_URL = `/api/v1/admin/device/farm/create`;
export const ASSIGN_WORKER_URL = `/api/v1/admin/device/farm/assign-worker`;
export const SERVICE_CHECK_HISTORY_URL = `/api/v1/admin/device/service-check-history`;

export const LOAD_SUB_ACCOUNT_URL = `/api/v1/admin/loadSubaccount`;
export const SAVE_SUB_ACCOUNT_URL = `/api/v1/admin/saveSubAccount`;
export const DELETE_SUB_ACCOUNT_URL = `/api/v1/admin/deleteSubAccount`;

export const LIST_ORDER_URL = `/api/v1/admin/list-order`;
export const LIST_ACTIVE_ORDER_URL = `/api/v1/admin/list-active`;
export const UPDATE_ORDER_URL = `/api/v1/admin/update-order`;
export const UPGRADE_DEVICE_URL = `/api/v1/admin/device/upgrade`;
export const UPDATE_MONITORING_URL = `/api/v1/admin/monitoring/update`;
export const CHANGE_NUMBER_URL = `/api/v1/admin/device/changeNumber`;
export const DELETE_CHANGE_NUMBER_URL = `/api/v1/admin/device/deleteChangeNumber`;
export const PING_URL = `/api/v1/admin/device/ping`;
export const CLEAR_CACHE_URL = `/api/v1/admin/device/clear-cache`;
export const COLLECT_LOGS_URL = `/api/v1/admin/device/collect-logs`;

export const CLICK_HISTORY_URL = '/api/v1/admin/device/click-history';
export const SENT_HISTORY_URL = '/api/v1/admin/device/sent-history';
export const STATUS_HISTORY_URL = '/api/v1/admin/device/status-history';

export const ADMIN_SERVLET_URL = `/api/v1/admin/adminServlet`;

export const DELETE_DID_URL = `/api/v1/admin/deleteDid`;
export const EXPORT_READFILE_URL = `/api/v1/file/readFile`;
export const MANAGE_USERS_URL = `/api/v1/manageUsersServlet`;
export const USER_SERVLET_URL = `/api/v1/userServlet`;

export const GET_BASED_COST_URL = `/api/v1/admin/getBasedCost`;
export const UPDATE_BASED_COST_URL = `/api/v1/admin/updateBasedCost`;
export const FINANCE_STATS_URL = `/api/v1/admin/getFinanceStats`;
export const GET_SERVICE_VENDOR_URL = `/api/v1/admin/getServiceVendor`;
export const GET_FULL_VENDOR_LIST_URL = `/api/v1/admin/general/loadFullVendorList`;

export const LIST_LOGIN_URL = '/api/v1/admin/device/farm/list-login';
export const TEST_LOGIN_URL = '/api/v1/admin/device/farm/test-login';

export const UPDATE_SERVICE_URL = `/api/v1/admin/premium/update-service`;
export const CANCEL_SERVICE_URL = `/api/v1/admin/premium/cancel-service`;
export const DELETE_DEVICE_URL = `/api/v1/admin/device/deleteDevice`;
export const ROLE_LIST_URL = `/api/v1/admin/role/list`;
export const PERMISSION_LIST_URL = `/api/v1/admin/role/list-permission`;
export const SAVE_ROLE_URL = `/api/v1/admin/role/save-role`;
export const SAVE_PERMISSION_URL = `/api/v1/admin/role/save-permission`;

export const ASSIGN_PERMISSION_URL = `/api/v1/admin/role/assign-permission`;
export const REVOKE_PERMISSION_URL = `/api/v1/admin/role/revoke-permission`;

export const AUTOMATION_TESTS_URL = `/api/v1/admin/automation-tests`;
export const SANITIZE_CONTACT_URL = '/api/v1/admin/contact/sanitize';

//* CREATIVE
export const OFFER_URL = `/api/v1/account/offer`;
export const DIALOG_URL = `/api/v1/account/dialog/loadDialogs`;
export const CONTACT_GROUP_URL = `/api/v1/admin/contact/getContactGroupsOfUser`;

export const GET_ATTACHMENT_CREATIVE_URL = `/api/v1/admin/creative/attachment/get`;

export const CLONE_USER_DATA_CREATIVE_URL = `/api/v1/admin/clone-data/clone-creative`;
export const CLONE_USER_DATA_OFFER_URL = `/api/v1/admin/clone-data/clone-offer`;
export const CLONE_USER_DATA_DIALOG_URL = `/api/v1/admin/clone-data/clone-dialog`;
export const CLONE_USER_DATA_CONTACT_GROUP_URL = `/api/v1/admin/clone-data/clone-contact-group`;

export const TICKETS_URL = `/api/v1/tickets`;

//* Guide
export const GUIDE_URL = `/api/v1/account/guide`;
export const GUIDE_BY_ROLE_URL = `/api/v1/account/guideByRole`;

export const ROUTE_INFO_LIST_URL = `/api/v1/route-info/list`;
export const SAVE_ROUTE_INFO_URL = `/api/v1/route-info/save`;
export const GET_ROUTE_DETAIL_URL = `/api/v1/route-info`;
export const DEFAULT_PRICE_URL = `/api/v1/route-info/default-price`;
export const DEFAULT_PRICE_UPDATE_URL = `/api/v1/route-info/default-price/update`;
export const DEFAULT_PRICE_SEARCH_URL = `/api/v1/route-info/default-price/search`;

export const MARKETING_LIST_URL = `/api/v1/admin/marketing/list`;
export const SAVE_MARKETING_URL = `/api/v1/admin/marketing/save`;
export const LIST_VENDOR_DOMAIN_URL = `/api/v1/admin/domain/listVendor`;

//* Authentication v2

export const V2_LOGIN_URL = '/api/v1/authentication/login';
export const V2_LOGOUT_URL = '/api/v1/authentication/logout';
export const V2_FORGOT_PASSWORD_URL = '/api/v1/authentication/forgot-password';
export const V2_RESET_PASSWORD_URL = '/api/v1/authentication/reset-password';

export const TEXTBACK_DIDs_DELETEs = '/api/v1/admin/textback-did/deleteDids';
export const TEXTBACK_DIDs_DELETE = '/api/v1/admin/textback-did/deleteDid';
export const TEXTBACK_DIDs_SEARCH = '/api/v1/admin/textback-did/searchDids';
export const TEXTBACK_DIDs_COUNT = '/api/v1/admin/textback-did/countDids';

export const SIM_LIST_URL = '/api/v1/admin/sim/list';
export const SIM_SAVE_URL = '/api/v1/admin/sim/save';
export const SIM_POOL_URL = '/api/v1/sim/pool';
export const SIM_SEND_URL = '/api/v1/sim/send';

//* 10-DLC
export const BRAND_URL = '/api/v1/admin/10dlc/brand';
export const PROFILE_URL = '/api/v1/admin/10dlc/profile';
export const USE_CASE_URL = '/api/v1/admin/10dlc/usecase';
export const REQUEST_10DLC_URL = '/api/v1/admin/10dlc/request10dlc';

export const VENDOR_10DLC_AVAILABLE_URL = '/api/v1/admin/general/loadFull10dlcVendorList';
export const USECASE_SENDER_URL = '/api/v1/usecase';

//* Shortlink
export const SHORTLINK_SEARCH_URL = '/api/v1/admin/shortlink/search';

//* Audit
export const AUDIT_CHANGES_URL = '/api/v1/admin/audit/changes';

//* Farm
export const FARM_LIST_URL = '/api/v1/admin/farm/list';
export const FARM_CREATE_URL = '/api/v1/admin/farm/create';

//* Sim order
export const SIM_ORDER_INVENTORY_LIST_URL = '/api/v1/admin/sim/order/list';
export const SIM_ORDER_INVENTORY_CREATE_URL = '/api/v1/admin/sim/order/create';
export const SIM_USAGE_LIST_URL = '/api/v1/admin/sim/usage/list';
export const SIM_HISTORY_STATS_URL = '/api/v1/admin/sim/history-stats';
export const SIM_CURRENT_STATS_URL = '/api/v1/admin/sim/current-stats';

//* Send email
export const SEND_EMAIL_URL = '/api/v1/admin/general/sendEmailToUsers';

//* Blacklist
export const SEARCH_SYSTEM_DNC_URL = '/api/v1/admin/blacklist/searchSystemDnc';
export const COUNT_SYSTEM_DNC_URL = '/api/v1/admin/blacklist/countSystemDnc';

export const SEARCH_10DLC_OPT_OUT = '/api/v1/admin/blacklist/search10DlcOptout';
export const COUNT_10DLC_OPT_OUT = '/api/v1/admin/blacklist/count10DlcOptout';

export const SIM_MOVE_TO_FARM_URL = '/api/v1/admin/sim/move-to-farm';

export const TENDLC_SUSPEND_URL = '/api/v1/admin/suspend10dlc';

//* Bank transfer
export const BANK_TRANSFER_URL = '/api/v1/bank-transfer';
export const BANK_TRANSFER_LIST_URL = '/api/v1/bank-transfer/list';
export const BANK_TRANSFER_POP_DOWNLOAD_URL = '/api/v1/bank-transfer/pop/download';
export const BANK_TRANSFER_UPDATE_URL = '/api/v1/bank-transfer/update';
export const DOWNLOAD_PROOF_URL = '/api/v1/file/download-proof';
export const DOWNLOAD_INVOICE_URL = '/api/v1/file/download-invoice';
export const DOWNLOAD_CREDIT_URL = '/api/v1/file/download-credit';

//* KYC
export const KYC_LIST_URL = '/api/v1/kyc/listAll';
export const KYC_DETAIL_URL = '/api/v1/kyc/user';
export const KYC_APPROVE_URL = '/api/v1/kyc/approveAndSubmit';
export const KYC_REJECT_URL = '/api/v1/kyc/rejectWithReason';

//* Finance
export const FINANCE_REPORTING_URL = '/api/v1/finance';

//* SMS To phonne
export const SMS_TO_PHONE_URL = '/api/v1/admin/sms-to-phone/search';

//* Orders SIM
export const ORDERS_URL = '/api/v1/sim/orders';

//* Background Process
export const BACKGROUND_TASK_URL = '/api/v1/general/generic-background-task';

//* VersionManagement
export const CAROUSEL_MEDIA_URL = '/api/v1/admin/carousel-media';
export const CAROUSEL_URL = '/api/v1/admin/carousel-list';
export const CAROUSEL_LIST_URL = '/api/v1/admin/carousel-listAll';
export const CAROUSEL_MEDIA_ID_URL = '/api/v1/admin/carousel-media-id';
export const CAROUSEL_PUBLISH = '/api/v1/admin/carousel-publish';

//* Campaign
export const CAMPAIGN_URL = '/api/v1/campaign';

//* MnoCarrier
export const KNOWN_MNO_CARRIER_URL = '/api/v1/mnocarrier/getAllKnown';
export const UNKNOWN_MNO_CARRIER_URL = '/api/v1/mnocarrier/getAllUnknown';
export const MAP_MNO_CARRIER_URL = '/api/v1/mnocarrier/mapUnknown';
export const CREATE_MNO_CARRIER_URL = '/api/v1/mnocarrier/create';
export const UNMAP_MNO_CARRIER_URL = '/api/v1/mnocarrier/unmap';

//* Stats
export const STATS_URL = '/api/v1/stats';

//* Modem management
export const MODEM_ROOT_URL = '/api/v1/modem';
export const MODEM_LIST_URL = '/api/v1/modem/devices';
export const MODEM_COUNT_URL = '/api/v1/modem/devices/count';
export const MODEM_CREATE_URL = '/api/v1/modem/ejoin';
export const MODEM_URL = '/api/v1/modem/modems';
export const MODEM_TEST_MSG_URL = '/api/v1/modem/sendMessage';

//* Traffic management
export const TRAFFIC_LIST_URL = '/api/v1/admin/traffic/all';

//* Error tracker
export const ERROR_STATS = '/api/v1/errorStatsRoute';

export const CREATIVE_URL = '/api/v1/creative';
export const CREATIVE_ASSISTANT_URL = `${CREATIVE_URL}/assistant`;

//* Audio
export const AUDIO_BUILDER_URL = '/api/v1/audio';

//* TFN
export const TFN_URL = '/api/v1/tfn';
export const VENDOR_TFN_AVAILABLE_URL = '/api/v1/admin/general/loadFullTfnVendorList';
export const VENDOR_UNREGISTERED_URL = '/api/v1/admin/general/loadFullUnregisteredVendorList';

//* SUBSCRIPTION PLAN
export const SUBSCRIPTION_PLAN_URL = '/api/v1/subscription';

//* Media storage URL
export const MEDIA_STORAGE_URL = '/api/v1/admin/media';
export const MEDIA_CAMPAIGN_URL = '/api/v1/account/campaign-media';

//* Referral - /api/v2/admin/referral
export const REFERRAL_URL = '/api/v1/referral';

//* Landing page - /api/v2/landingPage
export const LANDING_PAGE_URL = '/api/v1/landingPage';

//* Referral invoice - /api/v2/admin/referral
export const REFERRAL_INVOICE_URL = '/api/v1/referral';

//* Download inbox call recording
export const DOWNLOAD_CALL_RECORDING_URL = `/api/v1/file/download-call-recording`;

export const API_PACKAGE_URL = `/api/v1/api-package`;

//* Inbox V2
export const INBOX_V2_URL = '/api/v1/admin/inbox';

//* Error List Options
export const ERROR_LIST_OPTIONS_URL = '/api/v1/admin/general/error/enums';

//* Tutorial
export const TUTORIAL_URL = '/api/v2/admin/tutorial';
